import { render, staticRenderFns } from "./BuildingDetails.vue?vue&type=template&id=b7bce9aa&"
import script from "./BuildingDetails.vue?vue&type=script&lang=js&"
export * from "./BuildingDetails.vue?vue&type=script&lang=js&"
import style0 from "./BuildingDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports